export default (value: any) => {
    switch (value) {
        case "IT01": return "AMM. FINAN. MARKETING - BIENNIO COMUNE";
        case "IT04": return "TURISMO";
        case "IT05": return "MECC. MECCATRON. ENER. - BIENNIO COMUNE";
        case "IT10": return "ELETTR. ED ELETTROTEC.- BIENNIO COMUNE";
        case "IT13": return "INFOR. TELECOM. - BIENNIO COMUNE"; 
        case "ITAF": return "AMMINISTRAZIONE FINANZA E MARKETING - TRIENNIO"; 
        case "ITEN": return "ENERGIA"; 
        case "ITET": return "ELETTROTECNICA"; 
        case "ITIA": return "INFORMATICA"; 
        case "ITMM": return "MECCANICA E MECCATRONICA"; 
        case "LI03": return "SCIENTIFICO - OPZIONE SCIENZE APPLICATE"; 
    }
}